import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const aiDevToolsPlugin = createPlugin({
  id: 'ai-dev-tools',
  routes: {
    root: rootRouteRef,
  },
});

export const AiDevToolsPage = aiDevToolsPlugin.provide(
  createRoutableExtension({
    name: 'AiDevToolsPage',
    component: () =>
      import('./components/AiDevToolsPage').then(m => m.AiDevToolsPage),
    mountPoint: rootRouteRef,
  }),
);